import { S25Util } from "../../../util/s25-util";
import { RuleTreeService, type Rule } from "../../../services/rule.tree.service";
import type { ItemService } from "../../../util/items/item.service";
import { DataIngestionService, type IngestionFieldDefinition, type IngestionPoint } from "../data.ingestion.service";
import { hydrateIngestionRuleConditionValueNames } from "../ingestion.form.rule.hydrate.util";

export type IngestionFormPreviewData = {
    ingestionPoint: IngestionPoint;
    fieldDefinitions: IngestionFieldDefinition[];
    showHideRules: Rule[];
};

export async function loadIngestionShowHideRules(
    ingestionPointId: number,
    fieldDefinitions: IngestionFieldDefinition[],
    itemService: ItemService,
): Promise<Rule[]> {
    const rawRules = await RuleTreeService.getRulesBySubCategory("ingestion", ingestionPointId.toString(), true);
    const rules = S25Util.deepCopy(rawRules ?? []);
    await hydrateIngestionRuleConditionValueNames(rules, fieldDefinitions, itemService);
    return rules;
}

export async function loadSavedIngestionFormPreview(
    ingestionPointId: number,
    itemService: ItemService,
): Promise<IngestionFormPreviewData> {
    const [ingestionPoint, fieldDefinitionsRaw] = await Promise.all([
        DataIngestionService.getIngestionPoint(ingestionPointId),
        DataIngestionService.getFieldDefinitions(ingestionPointId),
    ]);
    if (!ingestionPoint) {
        throw new Error("Form not found.");
    }
    const fieldDefinitions = S25Util.deepCopy(fieldDefinitionsRaw.filter((fieldDef) => !fieldDef.isDeleted));
    const showHideRules = await loadIngestionShowHideRules(ingestionPointId, fieldDefinitions, itemService);
    return { ingestionPoint, fieldDefinitions, showHideRules };
}
